<div class="db-card" *ngIf="subscriberInfo">
  <div class="db-card-header">
    <div>
      <p class="db-card-title fw-600 text-size-20">Meet Your Local Real Estate Expert</p>
      <p class="text-size-14 fw-500 text-color-light-2 mt-1">
        Here to offer guidance, insight, and local market knowledge. You may hear from them soon.
      </p>
    </div>
  </div>
  <div class="db-card-body m-0">
    <ng-container>
      <div class="flex-box-lg-center-between mt-3">
        <div>
          <img [src]="subscriberInfo.logo" alt="company" class="company-logo" />
          <div class="flex-item-auto-sizing">
            <h3 *ngIf="subscriberInfo.name" class="text-size-16 fw-600 m-0">{{ subscriberInfo.name }}</h3>
            <span *ngIf="subscriberInfo.officePhone" class="text-color-grey-secondary grey mb-0 d-block">
              {{ subscriberInfo.officePhone.phone | phone }}
              <ng-container *ngIf="subscriberInfo.officePhone.ext"> Ext. {{ subscriberInfo.officePhone.ext }} </ng-container>
            </span>
            <span *ngIf="subscriberInfo.email" class="text-color-grey-secondary text-overflow-ellipsis d-block mw-400">{{
              subscriberInfo.email
            }}</span>
          </div>
        </div>
        <div class="mt-auto">
          <a
            *ngIf="subscriberInfo.website"
            class="button whitespace-nowrap ml-auto button-mid button-primary"
            [href]="subscriberInfo.website"
            target="_blank"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</div>
